import axios from 'axios';
import { decodeJwtPayload } from '../utils/jwtUtils';

console.log("API URL:", process.env.REACT_APP_FAP_API_URL);

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_FAP_API_URL, // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to dynamically append the Bearer token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken'); // Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Append Bearer token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Define a function to attach custom error handling
let onUnauthorized = null;

export const setUnauthorizedHandler = (callback) => {
  onUnauthorized = callback; // Set the handler for 401 errors
};

// Attach an interceptor to handle 401 responses
axiosInstance.interceptors.response.use(
  (response) => response, // Pass successful responses directly
  (error) => {
    if (error.response?.status === 401 && onUnauthorized) {
      const path = error.config?.url ?? '';
      if (!path.includes('Auth/Login') && !path.includes('Auth/Logout')) {
        const usedToken    = error.config?.headers?.Authorization?.replace('Bearer ', '');
        const currentToken = localStorage.getItem('accessToken');
        if (!usedToken || !currentToken || usedToken === currentToken) {
          // Check if the JWT is expired or if it's a newer token in Redis
          const payload = decodeJwtPayload(usedToken);
          const isTokenExpired = payload?.exp ? payload.exp < Date.now() / 1000 : false;
          onUnauthorized({ isTokenExpired });
        }
      }
    }
    return Promise.reject(error);
  }
);

// Define reusable methods for GET and POST
export const get = async (url, params = {}) => {
  try {
    const response = await axiosInstance.get(url, { params });
    return response.data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;
  }
};

export const post = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;
  }
};

export const put = async (url, data = {}) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error('PUT request error:', error);
    throw error;
  }
};

export default axiosInstance;